<template>
  <!-- Input Editable -->
  <div v-if="field._editable">
    <input
      v-if="isInput"
      v-model="field.value"
      class="f-input"
      ref="input"
      :class="{ 'f-input-load': this.load }"
      :type="fieldType"
      @keydown="readKey"
      @focusout="disable"
    >
    
    <select
      v-if="isReferenced"
      v-model="field.fieldId"
      class="f-input"
      ref="input"
      :class="{ 'f-input-load': this.load }"
      :title="columnTitle"
      @keydown="readKey"
      @focusout="disable"
    >
      <template v-if="loadOptions">
        <option
          class="f-input"
          ref="select"
          v-for="option in options"
          :key="option.value"
          :value="option.id"
        >
          {{ option.value }}
        </option>
      </template>
  
      <option v-else disabled>
        Carragando..
      </option>
    </select>
    
  </div>
  
  <div v-else class="f-container" :class="{ 'f-input-load': this.load }" :title="currentTitle">
    <input :value="field.value" class="f-input" disabled="disabled">

    <EditIcon
        v-if="isTableOwner"
        @click="enable"
        size="1.5x"
        class="f-icon-edit"
    />

    <InfoIcon
        size="1.5x"
        class="f-icon-info"
        @click="showFieldInfo = true"
    />

    <FieldInfo
        :column="column"
        :field="field"
        :table="table"
        v-if="showFieldInfo"
        @closed="showFieldInfo = false"
    />
  </div>
</template>

<script>
import FieldInfo from './FieldInfo.vue'
import ModelMapper from '@/mixins/ModelMapper'
import { EditIcon, InfoIcon } from 'vue-feather-icons'

export default {
  components: { EditIcon, FieldInfo, InfoIcon },
  computed: {
    columnTitle() {
      return 'Campo referenciado'
    },
    currentTitle(){
      return this.field.value
    },
    fieldType() {
      return this.column.type
    },
    isInput() {
      return ['text', 'number'].includes(this.column.type)
    },
    isReferenced() {
      return 'referenced' === this.column.type
    },
    options() {
      return this.rows.map(row => {
        const field = row.fields.find(f => f.index === this.column.valueIndex)
        
        return {
          id: field.id,
          value: field.value,
        }
      })
    }
  },
  created() {
    if (this.isInput) {
      this.backup = this.field.value
    } else {
      this.backup = this.field.referenced_field_id
      this.fetchRows()
    }
  },
  data: () => ({
    backup: '',
    load: false,
    loadOptions: false,
    nameModel: 'Field',
    rows: [],
    showFieldInfo: false,
  }),
  methods: {
    async asyncSave(data, headers) {
      data = {
        referenced_field_id: this.field.fieldId,
        value: this.field.value,
      }
      
      const url = `custom_table/tables/${this.table.id}/fields/${this.field.id}`
      return await this.axios.put(url, data, { headers: headers})
    },
    backupAndDisable() {
      this.field._editable = false
      if (this.isInput)
        this.field.value = this.backup
      else
        this.field.fieldId = this.backup
    },
    checkChange() {
      const match = (this.isInput && this.backup !== this.field.value) ||
                    (this.isReferenced && this.backup !== this.field.fieldId)
      if (match)
        this.save()
    },
    closeLoad() {
      this.load = false
    },
    disable() {
      this.field._editable = false
    },
    enable() {
      this.field._editable = true
    },
    fetchRows() {
      const tableKey = `rowsOfTable${this.column.tableId}`
      const backup = this.$ls.get(tableKey)
      if (backup) {
        this.rows = backup
        this.loadOptions = true
        return
      }
      
      const params = { per_page: 10000}
      this.axios.get(`custom_table/tables/${this.column.tableId}/rows`, { params })
        .then(response => this.rows = response.data)
        .then(() => this.loadOptions = true)
        .then(() => this.$ls.set(tableKey, this.rows, { minutes: 1 }))
      
    },
    openLoad() {
      this.load = true
    },
    readKey(event) {
      if (event.key === 'Enter' || event.key === 'Tab' || event.key === 'Escape')
        event.preventDefault()
  
      if (event.key === 'Escape') {
        this.backupAndDisable()
      } else if (event.shiftKey && event.key === 'Tab') {
        this.toJump('left')
      } else if (event.key === 'Tab') {
        this.toJump('right')
      } else if (event.shiftKey && event.key === 'Enter') {
        this.toJump('up')
      } else if (event.key === 'Enter') {
        this.toJump('down')
      }
    },
    save() {
      this.asyncTemplateSave(this.field, {
        after: ({model}) => this.setBackup(model),
        error: () => this.backupAndDisable()
      })
    },
    setBackup(field) {
      field = this.$parse.toCamelcase(field)
      Object.keys(field).forEach(key => this.field[key] = field[key])
      
      if (this.isInput)
        this.backup = field.value
      else
        this.backup = field.fieldId
    },
    setFocus() {
      this.$nextTick(() => this.$refs.input.focus())
    },
    toJump(position) {
      this.$emit('toJump', position)
    }
  },
  mixins: [ModelMapper],
  name: 'Field',
  props: {
    column: { required: true, type: Object },
    field: { required: true, type: Object },
    isTableOwner: { required: true, type: Boolean },
    table: { required: true, type: Object }
  },
  watch: {
    'field._editable'(newValue) {
      if (newValue)
        this.setFocus()
      else
        this.checkChange()
    }
  }
}
</script>

<style scoped>

.f-container {
  position: relative;
}

.f-input {
  width: 100%;
  padding: 4px 8px;
  border: 0;
  background-color: #FFF;
  transition: background-color 1s;
}
.f-input:disabled {
  background-color: #b5b7bb;
  transition: background-color 1s;
}

.f-input-load {
  background-color: rgba(248, 243, 166, 0.67);
  opacity: 0.5;
  transition: background-color 1s;
}

.f-icon-edit {
  cursor: pointer;
  position: absolute;
  z-index: 1;
  right: 4px;
  top: 4px;
}

.f-icon-edit:hover, .f-icon-info:hover {
  color: yellow;
}
.f-icon-info {
  cursor: pointer;
  position: absolute;
  z-index: 1;
  right: 24px;
  top: 4px;
}

</style>